import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import styles from './ColorSlider.module.scss';

const ColorSlider = React.forwardRef(
  ({ stops, thumbStyles, trackStyles, className, ...rest }, ref) => {
    const repaintSlider = React.useCallback(() => {
      if (ref?.current) {
        const el = ref.current;
        const range = el.max - el.min;
        const colors = stops.map(
          s =>
            `linear-gradient(${s.color},${s.color}) 0/calc(${s.value /
              range} * 100%) 100% no-repeat`,
        );
        el.style.setProperty(
          '--background',
          `${colors.join(',')}, ${
            className === 'vod-slider'
              ? 'rgba(0,0,0,0.5)'
              : 'rgba(200,200,200,0.5)'
          }`,
        );
      }
    });

    useEffect(() => {
      if (ref?.current) {
        const el = ref.current;
        el.style.setProperty(
          '--track-height',
          `${trackStyles?.height / 16}rem`,
        );
        el.style.setProperty('--thumb-width', `${thumbStyles?.width / 16}rem`);
        el.style.setProperty(
          '--thumb-height',
          `${thumbStyles?.height / 16}rem`,
        );
        el.style.setProperty('--thumb-background', thumbStyles?.background);
        el.style.setProperty(
          '--thumb-border-radius',
          `${thumbStyles?.borderRadius / 16}rem`,
        );
        el.style.setProperty(
          '--thumb-margin-top',
          `${(trackStyles?.height - thumbStyles?.height) / 32}rem`,
        );
      }
    }, []);

    useEffect(
      () => {
        repaintSlider();
      },
      [stops],
    );

    return (
      <div className={styles.container}>
        <div className={styles.slider}>
          <input
            className={`${styles.slider} ${className}`}
            type="range"
            ref={ref}
            {...rest}
          />
        </div>
      </div>
    );
  },
);

ColorSlider.propTypes = {
  stops: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func,
  thumbStyles: PropTypes.object,
  trackStyles: PropTypes.object,
  className: PropTypes.string,
};

export default ColorSlider;
